// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"1eaf0b5a","347":"cb913522","354":"71b3169a","686":"5744b5ae","805":"bebdaa91"}[chunkId] + ".chunk.css";
};